import createStore from './createStore';
import reducer from './reducer.ts';

export default createStore({ reducer });
